import type { ReactNode } from 'react'
import { PageHeader } from './PageHeader'

export function LegacyPage({
  title,
  description,
  actions,
  children,
}: {
  title: string
  description?: string
  actions?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="space-y-0">
      <PageHeader title={title} description={description} actions={actions} />
      {children}
    </div>
  )
}
